import { render, staticRenderFns } from "./IconAddSpace.vue?vue&type=template&id=b979ec76&scoped=true&"
import script from "./IconAddSpace.vue?vue&type=script&lang=js&"
export * from "./IconAddSpace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b979ec76",
  null
  
)

export default component.exports